import Fair from './Fair.jsx';
import AddFair from './Add.jsx';
import DetailFair from './Detail.jsx';
import EditFair from './Edit.jsx';
import FairBannerCategory from './FairBannerCategory.jsx';
import FairAdsPage from './FairAdsPage.jsx';

export { Fair, AddFair, DetailFair, EditFair, FairBannerCategory, FairAdsPage }


// WEBPACK FOOTER //
// ./pages/fair/index.js